import { IGestaoLogsControleReparo, IGestaoLogsControleReparoFiltro } from "../../../Interfaces/Geral/GestaoLogsControleReparo/GestaoLogsControleReparoInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarGestaoLogsControleReparoService(
    ID_PAGINA: number,
    requestBody: IGestaoLogsControleReparoFiltro,
    excel: boolean = false
) {
    return Service(
        Axios.post(`/assistenciatecnica/acaoatendimento/listardadosfechamentoassisteclog?ID_PAGINA=${ID_PAGINA}&excel=${excel}`,
            requestBody,
            { responseType: excel ? "blob" : "json" }
        )
    );
}